if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			// Optional
			loadProductFirst: true
		}
	};
}

// Declare Templates
var boostPFSTemplate = {
	'saleLabelHtml': '<div class="sale_banner">' + boostPFSConfig.label.sale + '</div>',
	'newLabelHtml': '<div class="new_banner">' + boostPFSConfig.label.new + '</div>',
	'comingsoonLabelHtml': '<div class="new_banner">' + boostPFSConfig.label.coming_soon + '</div>',
	'preorderLabelHtml': '<div class="new_banner">' + boostPFSConfig.label.pre_order + '</div>',
	'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',
	'vendorHtml': '<div class="vendor"><span itemprop="brand">{{itemVendorLabel}}</span></div>',
	'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery"><span class="icon-plus"></span></span>',
	'newRowHtml': '<br class="clear product_clear" />',

	// Grid Template
	'productGridItemHtml':  '<div data-boost-pfs-theme-quickview="{{itemId}}" data-product-id="{{itemId}}" class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}}" data-product-id="{{itemId}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product">' +
								'<a href="{{itemUrl}}" itemprop="url">' +
									'<div class="relative product_image">' +
										'<div class="product_container swap-' + boostPFSConfig.custom.collection_secondary_image + '">' +
											'{{itemImages}}' +
										'</div>' +
									'</div>' +
									'<div class="info">' +
										'<span class="title" itemprop="name">{{itemTitle}}</span>' +

										'{{itemVendor}}' +
										'{{itemReviews}}' +
										'{{itemPrice}}' +
									'</div>' +
									'<div class="banner_holder">' +
										'{{itemSaleLabel}}' +
										'{{itemNewLabel}}' +
										'{{itemComingsoonLabel}}' +
										'{{itemPreorderLabel}}' +
									'</div>' +
								'</a>' +
								'{{itemSwatches}}' +
							'</div>' +
							'{{itemNewRow}}',

	// Pagination Template
	'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + boostPFSConfig.label.paginate_prev + '</a></span>',
	'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + boostPFSConfig.label.paginate_next + ' »</a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="inline">' + '{{sortingLabel}}' + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>'
};

(function() {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index + 1;

		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		var itemHtml = boostPFSTemplate.productGridItemHtml;

		var onSaleClass = onSale ? 'sale' : '';
		var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';

		var itemColumnNumberClass = '';
		var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, boostPFSConfig.custom.products_per_row);
		var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemColumnNumberClass = boostPFSConfig.custom.show_sidebar ? 'six columns' : 'eight columns';
				break;
			case 3:
				itemColumnNumberClass = boostPFSConfig.custom.show_sidebar ? 'four columns' : 'one-third column';
				break;
			default:
				itemColumnNumberClass = boostPFSConfig.custom.show_sidebar ? 'three columns' : 'four columns';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);

		// Get image source
		var imageSrc = 'data-src="' + Utils.getFeaturedImage(images, '2048x') + '" ';
		imageSrc += 'data-srcset=" ' + Utils.getFeaturedImage(images, '2048x') + ' 2048w,';
		imageSrc += Utils.getFeaturedImage(images, '1600x') + ' 1600w,';
		imageSrc += Utils.getFeaturedImage(images, '1200x') + ' 1200w,';
		imageSrc += Utils.getFeaturedImage(images, '1000x') + ' 1000w,';
		imageSrc += Utils.getFeaturedImage(images, '800x') + ' 800w,';
		imageSrc += Utils.getFeaturedImage(images, '600x') + ' 600w,';
		imageSrc += Utils.getFeaturedImage(images, '400x') + ' 400w"';
		// Get Thumbnail url
		var thumbUrl = Utils.getFeaturedImage(images, '100x');
		// Get Flip image url
		var itemFlipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src'], '900x') : Utils.getFeaturedImage(images, '900x');

		// Add Thumbnail
		if (data.images_info.length > 0) {
			var product_set_width = data.images_info[0].width;
		} else {
			var product_set_width = '900';
		}
		var align_height_value = '';
		if (boostPFSConfig.custom.align_height) {
			if (images.length > 0) {
				var collection_height = boostPFSConfig.custom.collection_height;
				var product_aspect_ratio = images[0]['width'] / images[0]['height'];
				product_set_width = product_aspect_ratio * collection_height;
				if (images[0]['width'] >= images[0]['height']) {
					var align_height_value = 'width: 100%; height: auto;';
				} else {
					var align_height_value = 'width: 100%;';
				}
			}
		}
		var itemImagesHtml = '<div class="image__container" style="max-width: ' + product_set_width + 'px;">';
		itemImagesHtml += '<img  src="' + thumbUrl + '"' +
			'alt="{{itemTitle}}" ' +
			'class="lazyload lazyload--fade-in" ' +
			'style="' + align_height_value + ' max-width: ' + product_set_width + 'px;" ' +
			'data-sizes="auto" ' + imageSrc + '/>';
		// Add Flip image
		if (boostPFSConfig.custom.collection_secondary_image) {
			itemImagesHtml += '<div class="image__container" style="max-width: ';
			if (images.length > 1) {
				itemImagesHtml += images[1]['width'] + 'px';
			} else {
				itemImagesHtml += product_set_width + 'px';
			}
			itemImagesHtml += '">';
			itemImagesHtml += '<img src="' + itemFlipImageUrl + '" class="secondary lazyload" alt="{{itemTitle}}" />';
			itemImagesHtml += '</div>';
		}
		itemImagesHtml += boostPFSConfig.custom.quick_shop_enable ? '{{itemQuickViewBtn}}' : '';
		itemImagesHtml += '</div>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Labels
		// Sold Out label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
		// Sale label
		var itemSaleLabel = boostPFSConfig.custom.sale_banner_enabled && onSale ? boostPFSTemplate.saleLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
		// New, Coming soon, Pre order label
		var itemNewLabelHtml = '',
			itemComingsoonLabelHtml = '',
			itemPreorderLabelHtml = '';
		if (data.collections) {
			var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
			itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? boostPFSTemplate.newLabelHtml : '';

			var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
			itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? boostPFSTemplate.comingsoonLabelHtml : '';

			var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
			itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? boostPFSTemplate.preorderLabelHtml : '';
		}
		itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
		itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);
		itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);

		// Add Quick view button
		var itemQuickViewBtnHtml = boostPFSConfig.custom.quick_shop_enable ? boostPFSTemplate.quickViewBtnHtml : '';
		itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewHtml = boostPFSConfig.custom.review_enable ? boostPFSTemplate.reviewHtml : '';
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
		}

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		itemPriceHtml += '<span class="price ' + onSaleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
		itemPriceHtml += '<meta itemprop="price" content="' + Utils.stripHtml(Utils.formatMoney(data.price_min)) + '" />';
		itemPriceHtml += '<meta itemprop="priceCurrency" content="' + boostPFSConfig.shop.currency + '" />';
		itemPriceHtml += '<meta itemprop="seller" content="' + boostPFSConfig.shop.name + '" />';
		itemPriceHtml += '<meta itemprop="availability" content="' + soldOutClass + '" />';
		itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
		if (!soldOut) {
			if (priceVaries && data.price_min > 0) {
				itemPriceHtml += '<small><em>' + boostPFSConfig.label.from_price + '</em></small> ';
			}
			if (data.price_min > 0) {
				itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
			} else {
				itemPriceHtml += boostPFSConfig.label.free_price;
			}
		} else {
			itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
		}
		if (onSale) {
			itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span></span>';
		}
		itemPriceHtml += '</span>';
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Color swatches
		var itemSwatchHtml = '';
		if (boostPFSConfig.custom.collection_swatches) {
			for (var k in data.options) {
				if (data['options'][k].indexOf('color') > -1 || data['options'][k].indexOf('couleur') > -1) {
					var selectedOption = data['options'][k];
					var values = [];
					itemSwatchHtml += '<div class="collection_swatches">';
					for (var i = 0; i < data['variants'].length; i++) {
						var value = data['variants'][i]['option_' + selectedOption];
						if (values.indexOf(value) == -1) {
							values = values.join(',');
							values += ',' + value;
							values = values.split(',');
							var variantImage = boostPFSConfig.general.no_image_url;
							var temp = data.options_with_values.find(function(e) { return e.name == selectedOption; });
							if (temp) {
								var optionValues = temp['values'].find(function(e) { return e.title == value });
								if (optionValues) {
									var imageIndex = optionValues['image'];
									if (typeof(data['images_info'][imageIndex - 1]) !== 'undefined') {
										variantImage = data['images_info'][imageIndex - 1]['src'];
									}
								}
							}
							itemSwatchHtml += '<a href="' + Utils.buildProductItemUrl(data) + '?variant=' + data['variants'][i]['id'] + '" class="swatch">';
							itemSwatchHtml += '<span data-image="' + Utils.optimizeImage(variantImage, '1024x1024') + '" style="background-color: ' + Utils.slugify(value) + '; background-image: url(' + boostPFSConfig.general.asset_url.replace('boost-pfs.js', Utils.slugify(value) + '_50x.png') + ');"></span>'
							itemSwatchHtml += '</a>';
						}
					}
					itemSwatchHtml += '</div>';
				}
			}
		}
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchHtml);

		// Add new row
		var itemNewRowHtml = (index > 0 && index % boostPFSConfig.custom.products_per_row == 0) ? boostPFSTemplate.newRowHtml : '';
		itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Build advanced class
	function buildItemCollectionGroupThumbClass(index, productsPerRow) {
		var temp = index < productsPerRow ? index : index % productsPerRow;
		if (temp == 0) { return 'omega'; } else if (temp == 1) { return 'alpha'; }
		return '';
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
		return '';
	};

	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		console.log(Utils.isLoadPreviousPagePaginationType());
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var from = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		if (jQ(Selector.products + ' > column').length) {
			from -= jQ(Selector.products + ' > column').length - Globals.queryParams.limit;
		}
		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var to = product_index + this.data.products.length - 1;
		this.toProduct = to;

		return this.getTemplate('total')
			.replace(/{{progressLabel}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, from)
			.replace(/{{ to }}/g, to)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)

	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{sortingLabel}}/g, Labels.sorting);
			}
		}
		return html;
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function(colData, apiData) {
		if (!colData) colData = this.colData;
		if (!apiData) apiData = this.apiData;

		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;

			var breadcrumbHtml = '<span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="' + boostPFSConfig.shop.url + '" title="' + boostPFSConfig.shop.name + '" itemprop="item"><span itemprop="name">' + boostPFSConfig.label.breadcrumb_home + '</span></a></span>';
			breadcrumbHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
			breadcrumbHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/' + colInfo.handle + '" title="{{currentCollectionTitle}}" itemprop="item"><span itemprop="name">{{currentCollectionTitle}}</span></a></span>';
			// Build Tags
			var currentTagsHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags)) {
				var current_tags = boostPFSConfig.general.current_tags;
				for (var k in current_tags) {
					var tag = current_tags[k];
					currentTagsHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
					currentTagsHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/{{currentCollectionLink}}" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
				}
			}
			breadcrumbHtml += currentTagsHtml;
			// Build Collection Info
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
			// Top Pagination
			// var currentPage = parseInt(Globals.queryParams.page);
			// var totalPage = Math.ceil(apiData.total_product / Globals.queryParams.limit);
			// var topPaginationHtml = ' &nbsp;<span class="icon-arrow-right"></span> ' + (boostPFSConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, Globals.queryParams.page).replace(/{{ pages }}/g, totalPage)
			// breadcrumbHtml += topPaginationHtml;
			breadcrumbHtml += ' <span class="boost-pfs-filter-breadcrumb-page"></span>';

			return breadcrumbHtml;
		}
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		buildTheme();

		if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
			// Build content for Quick view
			ProductList.prototype.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
				results.forEach(function(result, index) {
					// Append the custom html to product item
					jQ('[data-boost-pfs-theme-quickview="' + result.id + '"]').append(result.quickview_html);
				});
				buildTheme();
			});
		}

		buildCurrentPageInBreadcrumb();
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Add Wrapper for Product list
		if (jQ('.boost-pfs-filter-products').children().hasClass('products')) {
			jQ('.boost-pfs-filter-products').children().children().unwrap();
		}

		buildCurrentPageInBreadcrumb();
	};

	function buildTheme() {
		collection.init();
		Shopify.PaymentButton.init();
		if (boostPFSConfig.custom.show_multiple_currencies && window.convertCurrencies && typeof convertCurrencies == 'function') {
			convertCurrencies();
		}
	}

	function buildCurrentPageInBreadcrumb() {
		// Build Breadcrumb
		var totalPage = Math.ceil(Globals.collectionCount / Globals.queryParams.limit);
		var topPaginationHtml = '&nbsp;<span class="icon-arrow-right"></span> ' + (boostPFSConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, Globals.queryParams.page).replace(/{{ pages }}/g, totalPage);
		jQ('.boost-pfs-filter-breadcrumb-page').html(topPaginationHtml);
	}

})();